export const InformationCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <circle cx="12" cy="12" r="11" />
        <path d="M12 10V18M12 7L12 6" />
      </g>
    </svg>
  );
};
